import Marquee from "react-fast-marquee";

const phrases = ["Awards-grade craft", "Performance engineering", "Never generic", "Interactive motion", "Built for conversion", "Designed for 2026"];

export default function EditorialMarquee() {
  return (
    <section data-testid="editorial-marquee-section" className="border-y border-white/10 bg-[#0F0F17]/70 py-6">
      <Marquee speed={28} gradient={false} className="overflow-hidden">
        {phrases.map((phrase) => (
          <span key={phrase} data-testid={`marquee-phrase-${phrase.toLowerCase().replaceAll(" ", "-")}`} className="mx-12 flex items-center gap-12 font-mono text-xs uppercase tracking-[0.32em] text-slate-500">
            {phrase}<span className="h-1.5 w-1.5 rounded-full bg-cyan-300 shadow-[0_0_18px_rgba(0,240,255,0.8)]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
